import AnimationModal from './AnimationModal';
import BaseMenu from './BaseMenu';
import NewTable from './newTable';
import SideMenu from './SideMenu';
import Tables from './Tables';
import CustomButton from './CustomButton';
import UploadMultiple from './UploadMultiple';
import PreviewDiscreteness from './PreviewDiscreteness';
import Editor from './Editor';
import RoomNumberItem from './RoomNumberItem';
import PageHeader from './PageHeader';

export { default as FormItemIdCard } from './FormItemIdCard';

export {
  BaseMenu,
  NewTable,
  SideMenu,
  AnimationModal,
  Tables,
  CustomButton,
  UploadMultiple,
  PreviewDiscreteness,
  Editor,
  RoomNumberItem,
  PageHeader,
};
